module.exports = __webpack_public_path__ + "img/IDS_Stat_Logo.91b57c46.png";